const BlogComponent = () => {
    return <div>Stay tuned yo</div>
};

export default BlogComponent;